import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const wipeAndRemigrateTeamSupportV2 = {
  name: "wipeAndRemigrateTeamSupportV2" as const,
  input: z.object({ teamId: zExt.objectId() }).strict(),
  output: z.object({ workflowId: z.string() }),
};
